import React from 'react'
// import { Link } from 'react-router-dom'

const Showcase = () => {
  return (
    <>
      <section className="showcase">
        <div className="overlay flex flex-col justify-center text-white text-center px-5 pt-32 lg:pr-10">
          <h1 className="font-bold tracking-wide text-5xl mb-8 lg:text-6xl xl:text-7xl 2xl:text-8xl">
            Deliveries in and around Nairobi.
            <br />
            <span className="text-yellow-500">Fast</span>,{' '}
            <span className="text-green-500">efficient</span> and{' '}
            <span className="text-blue-500">affordable</span>.
          </h1>
          <p className="text-2xl mb-5 xl:text-3xl">
            We deliver in Nairobi county and its environs daily from 6am to 8pm.
          </p>
          {/* <div className="mt-5">
            <Link
              to="/deliveries"
              className="bg-yellow-500 text-xl py-3 px-4 rounded border border-solid border-yellow-500 font-semibold tracking-widest transition-all hover:bg-gray-800 hover:border-white"
            >
              Make a request
            </Link>
          </div> */}
        </div>
      </section>
    </>
  )
}

export default Showcase
